// Generated by Copilot
import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { PourFormat } from '@barboxx/models';

const COLUMNS: GridColDef<PourFormat>[] = [
    {
        field: 'pourType.name',
        headerName: 'Pour Type',
        width: 120,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'volumeOz',
        headerName: 'Volume (oz)',
        width: 120,
    },
    {
        field: 'servingContainer.name',
        headerName: 'Glass type',
        width: 200,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'packagingFormat.name',
        headerName: 'Packaging Format',
        width: 200,
        valueGetter: dataGridNestedObjectValueGetter,
    },

    {
        field: 'productCategory.name',
        headerName: 'Alcohol Category',
        width: 200,
        valueGetter: dataGridNestedObjectValueGetter,
    },
];

interface Props {
    data: PourFormat[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function PourFormatTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Pour Formats">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
